import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';  
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-celen',
  templateUrl: './celen.component.html',
  styleUrls: ['./celen.component.scss']
})
export class CelenComponent implements OnInit {

  constructor( public authService: AuthService,public router:Router) { }
  idcliente;
  
  ngOnInit() {
    try {
      this.idcliente=localStorage.getItem("id_cliente");      
    } catch (error) {
      this.idcliente=0;
    }

    this.ls_celen();
  }
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
  loading;
  ls_celen(){
    let postData={
      id_cliente:this.idcliente    
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/get_celen",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this._celen=res;
           //console.log(data);          
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //console.log(di);
             swal.fire('¡API incorrecta..! ', '', 'error');
       });
  }
  regresacelen(){
    this.ls_celen();
    this.vcelen=1;
  
  }
  editacelen(){
    let postData={
      celen:this.celen    
     }
     //console.log(postData);
     this.authService.service("/api/upd_celen",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.ls_celen();
           swal.fire('Informacion guardada!', '', 'success');
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  eli_det(itm){
    if(confirm("Desea eliminar este registro?")==false)return;
    let postData={
      id:itm.id   
     }
     console.log(postData);
     this.authService.service("/api/eli_detcelen",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.ls_detcelen();
           swal.fire('Informacion guardada!', '', 'success');
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             swal.fire('¡API incorrecta..!', '', 'error');
       });
  }
  detcelen={
    lugar:"",
    descripcion:"",
    id_celen:0,
    id:0

  }
  _detcelen=[];
  pdfcelen(){
    localStorage.setItem("id_celen",this.celen.id.toString());
    this.router.navigate([]).then(result => {  window.open('#/celenfmt', '_blank'); }); 
  }
  pdf_tarea_(itm){    
    localStorage.setItem("id_celen",itm.id);
    this.router.navigate([]).then(result => {  window.open('#/celenfmt', '_blank'); }); 
  }
  pdf_tarea_mision_(){ 
    this.pdf_tarea_mision({id:this.celen.id.toString()})  
  } 
  pdf_tarea_mision(itm){    
    localStorage.setItem("id_celen",itm.id);
    this.router.navigate([]).then(result => {  window.open('#/fmtcelenmision', '_blank'); }); 
  }
  ls_detcelen(){
    let postData={
      id_celen:this.celen.id    
     }
     this.loading=true;
     console.log(postData);
     this.authService.service("/api/get_detcelen",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this._detcelen=res;
           console.log(data);          
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             //console.log(di);
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });  }
  gdadetcelen(){
    let postData={
      detcelen:this.detcelen    
     }
     //console.log(postData);
     this.authService.service("/api/gda_detcelen",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat);
           console.log(res);
           this.ls_detcelen();
           this.id_detcelen=res.insertId;
           console.log("detcelen:"+this.id_detcelen);
          
           try {
            this.uploadFileToActivity();  
           } catch (error) {             
           }           
           swal.fire('Informacion guardada!', '', 'success');
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  fn_vertarea(itm){
    this.vcelen=3;
    this.celen.antecedentes
    this.detcelen.id_celen=itm.id;
    this.celen={ 
      mision:itm.mision,
      vision:itm.vision,
      valores:itm.valores,
      proposito:itm.proposito,
      resumen:itm.resumen,  
      reunion:itm.reunion,    
      id_cliente:itm.id_cliente,
      id:itm.id,
      titulo:itm.titulo,
      observaciones:itm.observaciones,
      antecedentes:itm.antecedentes,
      responsables:itm.responsables,
      oportunidades:itm.oportunidades,
      objetivos:itm.objetivos,
      propuestas:itm.propuestas,
      fecha:itm.fecha
    }
    //console.log(this.celen)
    this.ls_detcelen();
    
  }
  vcelen=1;
  bndedita_celen=0;
  celen={     
    mision:"",
    vision:"",
    valores:"",
    proposito:"",
    resumen:"",
    reunion:0, 
    id_cliente:0,
    id:0,
    observaciones:"",
    titulo:"",
    antecedentes:"",
    responsables:"",
    oportunidades:"",
    objetivos:"",
    propuestas:"",
    fecha:""
  }
  _celen=[];
  gda_titulocelen(){
    this.celen.id_cliente=this.idcliente;
    let postData={
      celen:this.celen    
     }
     this.loading=true;
     //console.log(postData);
     this.authService.service("/api/gda_celen",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat); 
           this.ls_celen() 
           this.vcelen=1;     
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;             
             swal.fire('¡API incorrecta..! elim_Act', '', 'error');
       });
  }
  fileToUpload: File = null;
  public URL:any;
  hidCvePersona;
  ext_(f:any) {
    //console.log(f);
    var c:string[]=f.split("/");
   return c[(c.length-1)]; 
 }
  onSelectFile(event,idx) {
    //console.log(event);
    this.URL = event.target.files;
    this.fileToUpload = event.target.files[0];
  }
  id_detcelen=0;
  uploadFileToActivity(){
  console.log("upload");
   
    if (this.fileToUpload) {
      var reader = new FileReader();
      console.log("upload-ok");
      reader.readAsDataURL(this.fileToUpload); // read file as data url
      const file = this.fileToUpload;
      
      reader.onload = (event) => { 
        this.URL = reader.result;
  
        var tmpDate = new Date();     //  Wed Oct 16 2013 12:37:29 GMT+0200
        var now = tmpDate.getTime();
        let data: any = {
          cveentevt: 1,
          name: now + '.' + this.ext_(file.type),
          firma: this.URL,
          idx: 1,
          celen_id:this.id_detcelen
        }
        
        
        //this.persona.foto=data.name;
        data.TYPE = 'pdf';
        data.FILENAME = 'files/' + now + '.pdf',
        
         //this.loading =true;
        console.log(data);
          
          this.authService.upImagencelen(data).then(res => {
            var mm = JSON.stringify(res)
            var dd = JSON.parse(mm)
            this.msg_foto="<span class=green>✔</span> ";
            //console.log("guardado");
            //this.img1.id = res[0].cveevtanx;
            //this.img1.url = this.urlwebimg +  now + ".png";
            this.txt_fot=  now + ".png" 
            //this.loading =false;
              //this.PDF =  dd.detailed_message            
            //swal.fire('DOCUMENTO SE GUARDO EXITOSAMENTE','DOCUMENTO SE GUARDO EXITOSAMENTE','success')
              // console.log(dd.detailed_message)              
  
          },error => {
            this.msg_foto=" <span style=color:red;>X error</span> ";
          }
          )
        }
      }
  }
  msg_foto;
  txt_fot;

  fn_nvocelen(){
    this.vcelen=2;
    this.bndedita_celen=0;
    this.celen={    
      mision:"",
      vision:"",
      valores:"",
      proposito:"",
      resumen:"",
      observaciones:"", 
      reunion:0,     
      id_cliente:this.idcliente,
      id:0,
      antecedentes:"",
      titulo:"",
      responsables:"",
      oportunidades:"",
      objetivos:"",
      propuestas:"",
      fecha:""
    }
  }
}
